<template>
  <div>
     <div class="prompt" ref="errBox" v-show="error">{{infor1}}</div>
  </div>
</template>

<script>
  export default {
    props:{
      infor1:{
        type : String
      }
    },
    data () {
      return {
        error:false
      }
    },
    watch:{
      error:{
        handler(val,oldVal){
          if(val){
            var _self= this;
            setTimeout(function(){
              _self.$data.error= false
            },3000)
          }
        }
      }
    },
    methods:{
      errorShow () {
        this.error=true
      },
      errorHiden() {
        this.error=false
      }
    }
  }
</script>

<style scoped>

.prompt{
  width:80%;
  position: fixed;
  top:50%;
  left:50%;
  transform:translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(--50%, -50%);
  background:rgba(0,0,0,0.5);
  font-size:15px;
  color:#fff;
  padding:5px 10px;
  border-radius:15px;
  z-index:100;
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/prompt.vue